var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegradocomsitemercado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e00000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.25,41.83c-3.15-3.45-6.94-2.93-11-2.24,1.65-10.04,3.23-19.7,4.88-29.7-2.28,0-4.29.11-6.27-.04-1.27-.1-2.65-.34-3.75-.93C.96,7.78-.45,6,.13,3.34.6,1.2,2.64-.02,5.47,0c4.31.04,8.62.08,12.92.1,5.1.02,6.53,1.06,8,5.94,4.06-1.87,8.01-3.68,12.79-2.72,4.98,1,7.32,4.43,9.18,8.72,1.6-.99,2.97-1.89,4.39-2.72,5.24-3.07,10.59-3.16,15.73-.02,5.1,3.11,6.69,8.12,6.49,13.84-.04,1.14-.17,2.28-.34,3.41-.72,4.76-1.48,9.52-2.24,14.37-1.9-.66-3.65-1.57-5.48-1.81-1.77-.23-3.63.24-5.8.43.72-4.74,1.47-9.54,2.16-14.34.17-1.21.33-2.46.21-3.67-.4-3.93-3.04-6.11-7-5.93-4.14.19-7.66,3.54-8.2,7.59-.66,4.96-1.5,9.9-2.25,14.85-.33,2.2-1.57,3.11-3.81,3.08-6.31-.08-6.6-.34-5.65-6.58.62-4.08,1.29-8.15,2-12.22.83-4.81-.27-7.99-3.34-9.37-3.62-1.63-8.71-.13-11.23,3.49-.61.88-.78,2.12-.96,3.22-1.13,7.02-2.2,14.05-3.31,21.07-.04.23-.2.45-.51,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.91,40.9c3.37,0,6.21,3.03,6.16,6.57-.04,3.55-2.85,6.47-6.28,6.54-3.48.07-6.49-3.01-6.44-6.62.05-3.65,2.92-6.5,6.56-6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.81,47.34c.01,3.66-2.86,6.53-6.48,6.49-3.47-.04-6.25-2.92-6.26-6.45,0-3.5,2.81-6.45,6.23-6.5,3.59-.06,6.5,2.84,6.51,6.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegradocomsitemercado);
export default __webpack_public_path__ + "static/media/integrado com site mercado.810f89633ba745489bfad4672285387a.svg";
export { ForwardRef as ReactComponent };